import { Pipe, PipeTransform } from '@angular/core';

import { DeviceState } from '@app/store/device.model';

@Pipe({ name: 'deviceStateMessage' })
export class DeviceStateMessagePipe implements PipeTransform {
  static deviceStateToMessageMap: { [n: number]: string } = {};

  constructor() {
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.NO_FIRMWARE] = 'No Firmware';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.FAULT] = 'Fault State';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.FAULT_REACTION_ACTIVE] = 'Fault Reaction Active State';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.INCOMPATIBLE_FIRMWARE] = 'Incompatible Firmware';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.NOT_CONFIGURED] = 'Not Configured';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.WARNING] = 'Warning';
    DeviceStateMessagePipe.deviceStateToMessageMap[DeviceState.CONNECTED] = 'Connected';
  }

  transform(deviceState: DeviceState, _args?: any): string {
    return DeviceStateMessagePipe.deviceStateToMessageMap[deviceState];
  }
}
